import { Component, inject, Input, OnInit } from '@angular/core';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';

@Component({
  selector: 'app-p0003607-card-electrolyseur-statut',
  templateUrl: './p0003607-card-electrolyseur-statut.component.html',
  styleUrls: ['./p0003607-card-electrolyseur-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P0003607CardElectrolyseurStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];
  public buttonMode: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P0003600.card.state.filtration.status.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P0003600.card.state.filtration.status.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
        status: 'active',
      },
    ];

    this.buttonMode = [
      {
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
      },
      {
        icon: 'fa-kit fa-picto-horloge',
        color: 'color-orange',
      },
      {
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
      },
      {
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.ELECTROLYSEUR_STANDARD,
      FunctionOnglet.CONTROL,
      this.translateService.instant('P0003607.dashboard.electrolyseur'),
    );
  }
}
